export const ServerPreview = {
  flow: 'column',
  align: 'center space-between',
  gap: 'B',
  round: 'radiusControl',
  padding: 'Z2 A1',
  borderWidth: 'hairline',
  borderStyle: 'solid',
  theme: 'common-card-outline',
  SectionHeader: {
    margin: '0',
    padding: '0',
    title: (el) => el.call('polyglot', 'publish.envs.development')
  }
}
